var locationSelector = document.getElementById('location-selector');

locationSelector.addEventListener('change', function () {
    locationSelector.submit();
})